
import React, { Component } from 'react';
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import Axios from 'axios'
import { BASE } from "../api/api";

class Feedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      subject: '',
      msg: '',
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  validateEmail(email) {
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (reg.test(email) == false) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    this.topFunction()
  }

  fillalert(msg) {
    this.setState({
      fillalert: true,
      fillsuccess:msg?msg==="Feedback submitted" ? true : '':'',
      filltext: msg ? msg : ''
    })
    setTimeout(
      function () {
        this.setState({
          fillalert: null,
          fillsuccess: '',
          filltext: ''
        })
      }
        .bind(this),
      3000
    );
  }

  checkrequired() {
    if (this.state.email && this.state.name && this.state.subject && this.state.msg) {
      return true

    }
    else {
      this.setState({
        namealert: this.state.name ? null : true,
        emailalert: this.state.email ? null : true,
        subjectalert: this.state.subject ? null : true,
        msgalert: this.state.msg ? null : true
      })
      this.topFunction()
      this.fillalert()
    }
  }

  submit(e) {
    e.preventDefault();
    if (this.checkrequired()) {
      if (this.state.name) {
        if (this.state.email) {
          if (this.validateEmail(this.state.email)) {
            if (this.state.subject) {
              if (this.state.msg) {
                const formbody = {
                  "contact_form": [{ "target_id": "feedback" }],
                  "subject": [{ "value": this.state.subject }],
                  "message": [{ "value": this.state.msg }],
                  "field_email": [{ "value": this.state.email }],
                  "field_name": [{ "value": this.state.name }]
                }

                Axios(BASE + 'contact_message?_format=json', {
                  method: "POST",
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  data: formbody
                }) 
                  .then((res) => {
                    this.setState({
                      name: '',
                      email: '',
                      subject: '',
                      msg: '',
                      namealert: '',
                      emailalert: '',
                      subjectalert: '',
                      msgalert: ''

                    })
                    this.fillalert('Feedback submitted')
                  })
                  .catch((err) => {
                    console.log(err)
                    alert('Please enter valid details')
                  })
              }
              else
                alert('Please enter the message')
            }
            else
              alert('Please enter the subject')
          }
          else {
            this.fillalert('Invalid Email Address');
          }

        }
        else
          alert('Please enter the email')
      }
      else
        alert('Please enter the name')
    }
  }


  render() {

    return (
      <div className='formrea feedbackpage'>
        {this.state.fillalert ? <div className={this.state.fillsuccess ? "fill-alert fill-success" : "fill-alert"}>{this.state.filltext ? this.state.filltext : "Please enter all mandatory fields"}</div> : ''}

        <Header />
        <body className="listing feedback-pad">


          <div className="page-title">
            <div className="title-wrapper">
              <div className="container">
                <h1 className="heading">Enquiry & Feedback</h1>
              </div>
            </div>
          </div>

          <div className="main-content">
            <div className="container">
              <div className="row">
                <div className="region region-content">
                  <form className="webform-client-form webform-client-form-275" id="webform-client-form-275" accept-charset="UTF-8">
                    <div>
                      <div className="form-component">
                        <label for="edit-submitted-name">Name <span className="form-required" title="This field is required.">*</span></label>
                        <input id="name" name="name" type="text" value={this.state.name}
                          onChange={e => this.handleChange(e)} />
                        {this.state.namealert && !this.state.name ? <div class="alert-tag">The <strong>Name</strong> cannot be empty</div> : null}

                      </div>
                      <div className="form-component">
                        <label for="edit-submitted-email">Email <span className="form-required" title="This field is required.">*</span></label>
                        <input id="email" name="email" type="text" value={this.state.email}
                          onChange={e => this.handleChange(e)} />
                        {this.state.emailalert && !this.state.email ? <div class="alert-tag">The <strong>Email</strong> cannot be empty</div> : null}

                      </div>
                      <div className="form-component">
                        <label for="edit-submitted-email">Subject <span className="form-required" title="This field is required.">*</span></label>
                        <input id="subject" name="subject" type="text" value={this.state.subject}
                          onChange={e => this.handleChange(e)} />
                        {this.state.subjectalert && !this.state.subject ? <div class="alert-tag">The <strong>Subject</strong> cannot be empty</div> : null}
                      </div>
                      <div className="form-component form-component-textarea">
                        <label for="edit-submitted-message">Message <span className="form-required" title="This field is required.">*</span></label>
                        <div className="form-textarea-wrapper resizable"><textarea id="msg" name="msg" type="text" value={this.state.msg}
                          onChange={e => this.handleChange(e)} cols="60" rows="5" className="form-textarea required"></textarea></div>
                        {this.state.msgalert && !this.state.msg ? <div class="alert-tag">The <strong>Message</strong> cannot be empty</div> : null}
                      </div>
                      <button onClick={e => this.submit(e)}>Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </body>
        <Footer />
      </div>
    )
  }
}

export default Feedback;